
class DashboardController {
  /* @ngInject */
  constructor($http, $window, $state, Session, CASE_BUCKETS, moment) {
    this.$http = $http;
    this.$window = $window;
    this.$state = $state;
    this.Session = Session;
    this.moment = moment;
    this.buckets = CASE_BUCKETS;
    this.states = Session.read('states');
  }

  $onInit() {
    this.getCounts();
    this.getRecentActivities();
    this.activityHover = {};
    this.showChart = false;
    const user = this.Session.read('userinfo') || {};
    this.isVendor = user.client.type === 'VENDOR';
    this.userName = user.name || 'Anish Lushte';
    this.buckets = this.buckets[user.client.type]
      .filter(v => !(this.isVendor ? [
        'ALL', 'CLOSED', 'FINAL_REPORT_SUBMITTED',
      ] : [
        'ALL', 'CLOSED',
      ]).includes(v));
  }

  getCounts() {
    this.$http.get('/case/bucket')
      .then(({ data }) => {
        this.counts = data;
        this.showChart = this.counts.ALL;
        const chartData = this.buckets.map(v => ([v.replace(/_/g, ' '), data[v] || 0]));
        this.renderChart(chartData);
      });
  }

  getRecentActivities() {
    this.$http.get('/case/comment', {
      params: {
        limit: 20,
      },
    })
      .then(({ data }) => {
        this.activities = data;
      });
  }

  renderChart(data) {
    this.$window.c3.generate({
      bindto: '#status-chart',
      data: {
        columns: data,
        type: 'donut',
      },
    });
  }

  redirect(bucket) {
    this.$state.go('main.cases.list', { bucket });
  }

  getDisplayName(bucket) {
    return bucket.replace(/_/g, ' ');
  }
}

export default DashboardController;



// WEBPACK FOOTER //
// ./client/app/dashboard/dashboard.controller.js